// src/api/interceptor.js
import axios from "axios";

const api = axios.create({
  baseURL:process.env.REACT_APP_API_BASE_URL //"http://10.158.2.12:3001", // o tu baseURL si tienes
});

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem("practitioner_token");

    if (token) {
      config.headers.Authorization = `${token}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  error => Promise.reject(error)
);

export default api;
